import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

export default task(async function({ email }) {
  const api = inject(ApiService)
  await api.request({
    url: '/api/auth/recover',
    method: 'POST',
    data: { email }
  })
  return true
}, {
  defaultValue: null
})



// WEBPACK FOOTER //
// ./src/tasks/recoverPassword.js